// extracted by extract-css-chunks-webpack-plugin
module.exports = {"home_news_tag_circles":"HomeNewsTagCirclesPage__home_news_tag_circles--1FOhk","post_list":"HomeNewsTagCirclesPage__post_list--bEl18"};